import {InjectionToken} from '@angular/core';

export interface BusinessLogicRequirements {
  saveData(keyword, value);

}

export const BusinessRequirementsInjectionToken = new InjectionToken<BusinessLogicRequirements>('redirect Business Requirements')
